import type { ResearchOutlineResponse } from '@/components/ai/plugins/tech-research/types';
import type { PatSnapCommonResponseData } from '@patsnap/tahiti-core/common/ps-http';
import { PsHttpService } from '@patsnap/tahiti-core/common/ps-http';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { getUrlLlmModelHeader } from '@eureka/utils/llm-model';

export interface TechMindPushDirectionRequest {
  direction_list: any[];
  flow_id: string;
}

export interface TechMindPushDirectionResponse {
  success: boolean;
}

export interface ResearchOutlineRequest {
    job_id: string;
    framework: ResearchOutlineResponse
}

export interface AgentUserWaitingApi {
  techMindPushDirection(
    data: TechMindPushDirectionRequest
  ): Promise<TechMindPushDirectionResponse>;
  techResearchUpdateOutline(data: ResearchOutlineRequest): Promise<boolean>;
}

export const AgentUserWaitingApi = Symbol('AgentUserWaitingApi');

@injectable()
export class AgentUserWaitingApiImpl
    extends PsHttpService
    implements AgentUserWaitingApi {
    get options() {
        return {
            baseURL: `${import.meta.env.VITE_EUREKA_SERVICE_URI}`,
            headers: {
                'X-API-Version': '1.0',
                ...getUrlLlmModelHeader(),
            },
        };
    }

    techMindPushDirection(data: TechMindPushDirectionRequest) {
        return this.post<PatSnapCommonResponseData<TechMindPushDirectionResponse>>({
            url: '/eureka/agent/tech-mind/push-direction',
            data,
        }).then((res) => {
            return res as unknown as TechMindPushDirectionResponse;
        });
    }

    techResearchUpdateOutline(data: ResearchOutlineRequest) {
        return this.post<PatSnapCommonResponseData<boolean>>({
            url: '/eureka/agent/tech-research/update-outline',
            headers: {
                'X-Job-ID': '01e18868-e6cb-4a83-9ffe-d841d8498ec1',
            },
            data,
        }).then((res) => {
            return res as unknown as boolean;
        });
    }
}
